import { equals } from 'ramda'

import PlainButton from 'app/common/ui-next/plain-button'
import type { Survey, SurveyFilters } from 'app/common/types/surveys'

import { Filters } from '../../filters'
import { getDefaultFilters } from './getDefaultFilters'
import styles from './SurveyDetailsFilters.module.scss'

type Props = {
  survey: Survey
  value: SurveyFilters
  appliedValue: SurveyFilters
  onChange: (value: SurveyFilters) => void
  onApply: () => void
}

export const SurveyDetailsFilters = ({
  survey,
  value,
  appliedValue,
  onChange,
  onApply,
}: Props) => {
  const handleReset = () => onChange(getDefaultFilters(survey))

  return (
    <>
      <Filters
        scope={survey}
        value={value}
        onChange={onChange}
        periodDisabled
      />
      <div className={styles.actions}>
        <PlainButton
          outline
          disabled={equals(value, getDefaultFilters(survey))}
          onClick={handleReset}
        >
          {'Сбросить все фильтры'}
        </PlainButton>
        <PlainButton disabled={equals(value, appliedValue)} onClick={onApply}>
          {'Применить'}
        </PlainButton>
      </div>
    </>
  )
}
